import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  defineAsyncComponent,
  onMounted,
  computed,
  getCurrentInstance
} from 'vue';

// Helpers
import { useClampTabControl } from '@white-label-helper/shared-composables';
import { trackUpsellImpression, trackUpsellClick } from '@white-label-helper/ga-tracking';
import { getFeatureFlag, trackLaunchDarklyEvent, trackLaunchDarklyExperimentImpression } from '@white-label-plugin/launch-darkly';
import { FEATURE_FLAGS } from '@white-label-configuration/constants';

// Types
import type { SearchProducts } from '@white-label-types/parking-booking';

// Components
import { Button as ControlButton } from 'ui-shared-components';

// Mocks
import mockedTravelInsuranceProduct from './mockedTravelInsuranceProduct.json'

import travelInsuranceImage from './assets/travel-insurance.jpg';

interface TravelInsuranceProductCardProps {
  product?: Partial<SearchProducts>;
  battlefacePartnerId: Number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'travel-insurance-upsell-card',
  props: {
    product: { default: () => ({}) },
    battlefacePartnerId: null
  },
  setup(__props: any, { expose }) {

const props = __props as { product: Partial<SearchProducts>, battlefacePartnerId: Number };

const IconCheck = defineAsyncComponent(() => import('@white-label-icon/icon-check'));
const IconLink = defineAsyncComponent(() => import('@white-label-icon/icon-link'));



const instance = getCurrentInstance();
const proxy = instance?.proxy;

const clampedContainer = ref(null);
const startQuote = ref<any>(null);

const onButtonClick = () => {
  if (proxy?.$gtm) {
    trackUpsellClick(proxy.$gtm, product.value, props.battlefacePartnerId);
  }

  if (upsellUrl.value) {
    window.open(upsellUrl.value, '_blank', 'noopener,noreferrer');
  }

  trackLaunchDarklyEvent('insurance_card_click');
}

onMounted(() => {
  useClampTabControl(clampedContainer);
  if (proxy?.$gtm) {
    trackUpsellImpression(proxy.$gtm, product.value);
  }
  trackLaunchDarklyExperimentImpression(proxy?.$gtm, FEATURE_FLAGS.CRO_1287_REPOSITION_INSURANCE_CARD_ON_RECEIPT_PAGE, 'cro-1287');
});

const product = computed(() => {
  if (!props.product || Object.keys(props.product).length === 0) {
    return mockedTravelInsuranceProduct;
  }
  return props.product;
});

const upsellUrl = computed(() => {
  return `https://app.battleface.com?partner=${props.battlefacePartnerId}&external_reference_id=CONFPAGE`;
});

const insuranceRepositionFlagValue = computed(() => getFeatureFlag(FEATURE_FLAGS.CRO_1287_REPOSITION_INSURANCE_CARD_ON_RECEIPT_PAGE, 'control'));

const cardTitle = computed(() => {
  if (insuranceRepositionFlagValue.value === 'top_without_image') {
    return 'Protect your trip with Travel Insurance';
  } else {
    return product?.value?.product_option?.name;
  }
});

const experimentUIClass = computed(() => {
  if (insuranceRepositionFlagValue.value === 'top_without_image') {
    return 'upsell-on-top-without-image';
  } else if (insuranceRepositionFlagValue.value === 'top_with_image') {
    return 'upsell-on-top';
  } else {
    return '';
  }
});

expose({
  upsellUrl,
})

return { __sfc: true,IconCheck, IconLink, props, instance, proxy, clampedContainer, startQuote, onButtonClick, product, upsellUrl, insuranceRepositionFlagValue, cardTitle, experimentUIClass, ControlButton, travelInsuranceImage }
}

})